export default {
  title: {
    roleManagement: '角色管理',
    roleAdd: '增添角色',
    roleEdit: '编辑角色'
  },
  menu: '角色管理',
  label: {
    roleName: '角色名称',
    permissionSource: '可分配的权限:',
    permissionTarget: '已分配权限:',

    company: '公司',
    email: '邮箱地址',
    role: '角色',
    status: '状态',
    option: '操作',
    companyName: '公司名称',
    addUser: '新增用户',
    editUser: '编辑用户',
    firstName: '名字',
    lastName: '姓氏',
    chineseName: '中文姓名',
    primaryEmail: '邮箱地址',
    secondaryEmail: '其他邮箱地址',
    mobile: '手机号码',
    employeeId: '员工ID',
    reportTo: '汇报对象',
    programType: '项目类别',
    clientName: '客户名称',
    costCentre: '成本中心',
    roleType: '角色类型',
    roleTitle: '角色管理',
    roleHead: '给 {lastName} {firstName} 在 {company} 分配角色 {email}'
  },
  placeholder: {
    roleName: '请输入角色名称',
    // n
    firstName: '请输入名字',
    lastName: '请输入姓氏',
    chineseName: '请输入中文姓名',
    company: '请选择公司',
    secondaryEmail: '请输入其他邮箱地址',
    mobile: '请输入手机号码',
    employeeId: '请输入员工ID',
    reportTo: '请选择汇报对象',
    programType: '请选择项目类别',
    clientName: '请输入客户名称',
    costCentre: '请输入成本中心',
    roleType: '请选择角色类型',
    role: '请选择角色',
    email: '请输入邮箱',
    primaryEmail: '请输入邮箱',
    phone: '请输入手机',
    name: '请输入姓名'
  },
  btn: {
    addRole: '添加角色'
  },
  message: {
    optionSuccess: '操作成功',
    optionField: '操作失败',
    roleNameRequired: '这是必填项。',
    titleExists: '此账号名已经存在!',
    deleteConfirm: '是否要删除该角色 {roleName} ?',

    userTip: '{activeCount}个活跃账户数/{totalCount}个总可用账户数',
    userRequired: '这是必填项。',
    emailExist: '此邮箱地址已被注册。',
    emailValid: '输入一个有效的 e-mail 地址。',
    mobileExist: '该手机号码已经被绑定了。',
    resetPassword: '重置密码邮件已发, 可在几分钟内查收.',
    expireDateClosed: '请联系菁客申请添加更多的账户'
  }
}
